import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-footbar-config',
  templateUrl: './user-footbar-config.component.html',
  styleUrls: ['./user-footbar-config.component.scss']
})
export class UserFootbarConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
